import { ButtonTheme } from '../../../../components/buttons';
import { RenderForm } from '../../../../components/forms';
import { ModalTheme } from '../../../../components/modal';
import { ContainerButton } from '../../../../styles/global-style';
import { FORM_EDIT_EXPIRED } from '../form';
import { useEffect } from 'react';
import { useUpdateExp } from '../hooks/useUpdateExp';
import { Spin } from 'antd';
import { useForm } from 'react-hook-form';
import React from 'react';

export const UpDateExpModal = ({ open, onToggle, dataExp }) => {
  const { control, getValues, setValue, handleSubmit } = useForm();
  const { mutate: onEditExp, loading: isLoadingEditExp } = useUpdateExp();

  const onSubmit = (value) => {
    onEditExp(value);
    onToggle({ defaultValues: '' });
  };

  useEffect(() => {
    setValue('warrantyId', dataExp?.warrantyId);
    setValue('expireDate', dataExp?.expireDate);
  }, [dataExp]);

  return (
    <Spin spinning={isLoadingEditExp}>
      <ModalTheme title="แก้ไขวันหมดอายุ" open={open} onToggle={onToggle}>
        <RenderForm
          control={control}
          setValue={setValue}
          getValues={getValues}
          forms={FORM_EDIT_EXPIRED()}
        />
        <ContainerButton right>
          <ButtonTheme useFor="SUBMIT" onClick={handleSubmit(onSubmit)} />
          <ButtonTheme useFor="CANCEL" onClick={onToggle} />
        </ContainerButton>
      </ModalTheme>
    </Spin>
  );
};
